import { render, staticRenderFns } from "./batchAssociationModal.vue?vue&type=template&id=190b35b8"
import script from "./batchAssociationModal.vue?vue&type=script&lang=js"
export * from "./batchAssociationModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports